export const flyToCart = (sourceEl, imageSrc) => {
    if (!sourceEl || !imageSrc) return;

    const targets = Array.from(document.querySelectorAll("[data-cart-target]"));

    const target = targets.find((el) => {
        const rect = el.getBoundingClientRect();
        const style = window.getComputedStyle(el);

        return (
            rect.width > 0 &&
            rect.height > 0 &&
            style.display !== "none" &&
            style.visibility !== "hidden" &&
            style.opacity !== "0"
        );
    });

    if (!target) return;

    const startRect = sourceEl.getBoundingClientRect();
    const endRect = target.getBoundingClientRect();

    const flyingImg = document.createElement("img");
    flyingImg.src = imageSrc;
    flyingImg.alt = "";
    flyingImg.style.position = "fixed";
    flyingImg.style.left = `${startRect.left}px`;
    flyingImg.style.top = `${startRect.top}px`;
    flyingImg.style.width = `${startRect.width}px`;
    flyingImg.style.height = `${startRect.height}px`;
    flyingImg.style.objectFit = "cover";
    flyingImg.style.borderRadius = "12px";
    flyingImg.style.pointerEvents = "none";
    flyingImg.style.zIndex = "99999";
    flyingImg.style.transition =
        "transform 750ms cubic-bezier(0.22, 1, 0.36, 1), opacity 750ms ease";
    flyingImg.style.transform = "translate(0, 0) scale(1)";
    flyingImg.style.opacity = "1";
    flyingImg.style.boxShadow = "0 12px 30px rgba(0,0,0,0.18)";

    document.body.appendChild(flyingImg);

    const startCenterX = startRect.left + startRect.width / 2;
    const startCenterY = startRect.top + startRect.height / 2;
    const endCenterX = endRect.left + endRect.width / 2;
    const endCenterY = endRect.top + endRect.height / 2;

    const deltaX = endCenterX - startCenterX;
    const deltaY = endCenterY - startCenterY;

    requestAnimationFrame(() => {
        flyingImg.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(0.16)`;
        flyingImg.style.opacity = "0.25";
    });

    setTimeout(() => {
        target.classList.remove("cart-bump");
        void target.offsetWidth;
        target.classList.add("cart-bump");
    }, 520);

    setTimeout(() => {
        flyingImg.remove();
        target.classList.remove("cart-bump");
    }, 820);
};
